import { useEffect, useState } from "react";

function calc(target) {
  const diff = target - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  const d = Math.floor(diff / 86_400_000);
  const h = Math.floor((diff % 86_400_000) / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  const s = Math.floor((diff % 60_000) / 1000);
  return { d, h, m, s, done: false };
}

export default function Countdown({ target, label = "Countdown" }) {
  const targetMs = new Date(target).getTime();
  const [t, setT] = useState(() => calc(targetMs));

  useEffect(() => {
    const id = setInterval(() => setT(calc(targetMs)), 1000);
    return () => clearInterval(id);
  }, [targetMs]);

  const Unit = ({ value, unit }) => (
    <div className="flex flex-col items-center justify-center">
      <div className="font-display text-5xl md:text-6xl font-extrabold tracking-tighter font-mono-tab">
        {String(value).padStart(2, "0")}
      </div>
      <div className="text-[10px] uppercase tracking-[0.25em] text-white/60 mt-2">{unit}</div>
    </div>
  );

  return (
    <div data-testid="countdown-block">
      <div className="text-[11px] uppercase tracking-[0.3em] text-white/60 mb-6">{label}</div>
      {t.done ? (
        <div className="font-display text-4xl text-white">It has begun.</div>
      ) : (
        <div className="grid grid-cols-4 gap-6 md:gap-12 text-white">
          <Unit value={t.d} unit="Days" />
          <Unit value={t.h} unit="Hours" />
          <Unit value={t.m} unit="Min" />
          <Unit value={t.s} unit="Sec" />
        </div>
      )}
    </div>
  );
}
